import { AxiosInstance } from "axios";
import { PushMessagePayload } from "../types/message/message-payload";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

enum MessageApiUrl {
  Push = "/setting/alert",
}

class MessageApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async postPush(payload: PushMessagePayload): Promise<OngBaseResponse<null>> {
    return await this._api.post(MessageApiUrl.Push, payload);
  }
}

export const messageApi = new MessageApi(ongBaseApi);
